import { createElement as e, forwardRef as t } from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { elMb5 as i } from "@reapit/elements/deprecated/styles";
//#region ../../node_modules/@linaria/core/dist/index.mjs
var a = function() {
	let e = Array.prototype.slice.call(arguments).filter(Boolean), t = {}, n = [];
	e.forEach((e) => {
		(e ? e.split(" ") : []).forEach((e) => {
			if (e.startsWith("atm_")) {
				let [, n] = e.split("_");
				t[n] = e;
			} else n.push(e);
		});
	});
	let r = [];
	for (let e in t) Object.prototype.hasOwnProperty.call(t, e) && r.push(t[e]);
	return r.push(...n), r.join(" ");
};
//#endregion
//#region ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function o(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
//#endregion
//#region ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var s = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, c = /* #__PURE__ */ o(function(e) {
	return s.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
}), l = (e) => e.toUpperCase() === e, u = (e) => (t) => e.indexOf(t) === -1, d = (e, t) => {
	let n = {};
	return Object.keys(e).filter(u(t)).forEach((t) => {
		n[t] = e[t];
	}), n;
};
function f(e, t, n) {
	let r = d(t, n);
	if (!e) {
		let e = typeof c == "function" ? { default: c } : c;
		Object.keys(r).forEach((t) => {
			e.default(t) || delete r[t];
		});
	}
	return r;
}
function p(n) {
	return (r) => {
		let i = (t, i) => {
			let { as: o = n, class: s = "" } = t, c = f(r.propsAsIs === void 0 ? !(typeof o == "string" && o.indexOf("-") === -1 && !l(o[0])) : r.propsAsIs, t, ["as", "class"]);
			c.ref = i, c.className = r.atomic ? a(r.class, c.className || s) : a(c.className || s, r.class);
			let { vars: u } = r;
			if (u) {
				let e = {};
				for (let n in u) {
					let i = u[n], a = i[0], o = i[1] || "", s = typeof a == "function" ? a(t) : a;
					r.name, e[`--${n}`] = `${s}${o}`;
				}
				let n = c.style || {}, i = Object.keys(n);
				i.length > 0 && i.forEach((t) => {
					e[t] = n[t];
				}), c.style = e;
			}
			return n.__wyw_meta && n !== o ? (c.as = o, e(n, c)) : e(o, c);
		}, o = t ? t(i) : ((e) => i(d(e, ["innerRef"]), e.innerRef));
		return o.displayName = r.name, o.__wyw_meta = {
			className: r.class || "",
			extends: n
		}, o;
	};
}
//#endregion
//#region src/loader-box/index.tsx
var m = /*#__PURE__*/ p("div")({
	name: "StyledCard",
	class: "s1uc8792",
	propsAsIs: !1
}), h = ({ className: e, children: t, ...r }) => /* @__PURE__ */ n("div", {
	className: a("w1yaav9t", e),
	...r,
	children: t
}), g = ({ className: e, children: t, ...r }) => /* @__PURE__ */ n("div", {
	className: a("s1r0j4it", e),
	...r,
	children: t
}), _ = ({ className: e, children: t, ...r }) => /* @__PURE__ */ n(m, {
	className: e,
	...r,
	children: t
});
_.LoaderBodyWrapper = h, _.LoaderBodySectionWrapper = g;
//#endregion
//#region src/loading-skeleton/index.tsx
var v = ({ variant: e = "rectangle", width: t = "100%", height: r = "1rem", className: i }) => /* @__PURE__ */ n("div", {
	className: a("sbi06ha", e, i),
	style: {
		width: t,
		height: r
	}
}), y = (e) => e.isShow ? /* @__PURE__ */ r(_, {
	role: "progressbar",
	children: [/* @__PURE__ */ n(v, {
		className: i,
		height: "1.5rem"
	}), /* @__PURE__ */ r(_.LoaderBodyWrapper, { children: [
		/* @__PURE__ */ r(_.LoaderBodySectionWrapper, {
			style: { gap: "0.25rem" },
			children: [/* @__PURE__ */ n(v, { height: "1.25rem" }), /* @__PURE__ */ n(v, {
				height: "1.25rem",
				width: "75%"
			})]
		}),
		/* @__PURE__ */ r(_.LoaderBodySectionWrapper, {
			style: { gap: "0.25rem" },
			children: [
				/* @__PURE__ */ n(v, {}),
				/* @__PURE__ */ n(v, {}),
				/* @__PURE__ */ n(v, { width: "75%" })
			]
		}),
		/* @__PURE__ */ r(_.LoaderBodySectionWrapper, {
			style: { gap: "0.25rem" },
			children: [/* @__PURE__ */ n(v, {}), /* @__PURE__ */ n(v, { width: "75%" })]
		})
	] })]
}) : null;
//#endregion
export { _ as LoaderBox, y as LoaderCards, v as LoadingSkeleton };
